import {API_URL, CMS_URL, THEME_COLOR} from "../constant"
import React, { useEffect, useState } from 'react';
import HeaderBack from "../layout/HeaderBack";
import { useLocalStorage } from "../useLocalStorage";
import M from "materialize-css";
import Box from '@mui/material/Box';
import StepButton from '@mui/material/StepButton';
import Button from '@mui/material/Button';
import { Card, CardMedia, CardContent, Divider } from "@mui/material";
import Typography from '@mui/material/Typography';
import StepLabel from '@mui/material/StepLabel';
import Select from 'react-select';
import { Link,useHistory } from "react-router-dom";
import TextField from '@mui/material/TextField';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';

import toast, { Toaster } from 'react-hot-toast';
// import { Link } from "react-router-dom";

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';


const ResetPassword = (props)=>{
    const [token, setToken] = useLocalStorage("token", "");
    const [oPassword, setOPassword] = useState("");
    const [nPassword, setNPassword] = useState("");
    const [cPassword, setCPassword] = useState("");
    const [isOpenBackdrop, setIsOpenBackdrop] = useState(false);
    const [key, setKey] = useState("")
    let history = useHistory();


    function reset(){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);

        var urlencoded = new URLSearchParams();
        urlencoded.append("oPassword", oPassword);
        urlencoded.append("nPassword", nPassword);
        urlencoded.append("cPassword", cPassword);
        urlencoded.append("key", key);

        var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/auth/resetpassword`, requestOptions)
        .then(response => response.json())
        .catch(error => {});
    }

    async function ResetPassword(){
        setIsOpenBackdrop(true)
        let response = await reset();
        if(response.status == 200){
            toast.success(response.message);
            history.goBack();
        }else{
            toast.error(response.message);
        }
        setIsOpenBackdrop(false)
    }

    useEffect(()=>{
        let search = props.location.search;
        const params = new URLSearchParams(search);
        setKey(params.get("k"));
        if((!token || token == "")&& (!params.get("k") || params.get("k") == "")){
            window.location = "/";
        }
    },[])

    return(
        <React.StrictMode>
            <Toaster
                position="bottom-center"
            />
            <HeaderBack title="Reset Password" />
            <Box mt={5}></Box>
            <div className="row">
                <form className="col s12">
                    {
                        (token && token != "")? (
                            <div className="input-field col s12">
                                <i className="material-icons prefix">lock</i>
                                <input id="OPassword" type="password" className="validate" onChange={ e => setOPassword(e.target.value)}/>
                                <label htmlFor="OPassword">Old Password</label>
                            </div>
                        ):(<></>)
                    }
                    <div className="input-field col s12">
                        <i className="material-icons prefix">lock</i>
                        <input id="NPassword" type="password" className="validate" onChange={ e => setNPassword(e.target.value)}/>
                        <label htmlFor="NPassword">New Password</label>
                    </div>
                    <div className="input-field col s12">
                        <i className="material-icons prefix">lock</i>
                        <input id="CPassword" type="password" className="validate" onChange={ e => setCPassword(e.target.value)}/>
                        <label htmlFor="CPassword">Confirm Password</label>
                    </div>
                </form>
            </div>
            <div className="row center">
                    <Box width="100%" mt={2}>
                        <Button variant="contained" style={{backgroundColor:"#ee4d2d"}} onClick={ResetPassword}>Reset</Button>
                    </Box>
            </div>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isOpenBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </React.StrictMode>
    );
}


export default ResetPassword;